import { useEffect, useState } from "react";
import Button from "@/components/ui/button";
import {
    Dialog,
    DialogBody,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { useTranslations } from "@/features/translations/components/translations";
import { useAppSelector } from "@/redux/store.ts";

export default function UsedDifferentSmartNumber() {
    const t = useTranslations();

    const usesDifferentSmartNumber = useAppSelector((state) => state.smartNumber.usesDifferentSmartNumber);

    const [open, setOpen] = useState<boolean>(false);

    const onOpenChange = (isOpening: boolean) => {
        setOpen(isOpening);

        if (!isOpening) removeUserInput();
    };

    useEffect(() => {
        setOpen(usesDifferentSmartNumber);
    }, [usesDifferentSmartNumber]);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{t("change_features_title")}</DialogTitle>
                </DialogHeader>
                <DialogBody>{t("different_configuration_description")}</DialogBody>

                <DialogFooter>
                    <DialogClose asChild>
                        <Button variant="action" background="dark">
                            {t("continue")}
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

// region Helpers
const removeUserInput = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("userInput");
    history.pushState({}, "", url.toString());
};
// endregion
